/*
  Burro Singles — MTG Set App
  Versión de mantenimiento 5.1
  Cambio: eliminación de cinco funciones duplicadas sin alterar comportamiento.
  Fuente: burro-mtg-set-app.js de producción.
*/
(function(){
  function qs(id){ return document.getElementById(id); }
  function esc(s){ return String(s||'').replace(/[&<>"']/g,function(m){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])});}
  function debounce(fn, ms){ var t; return function(){ clearTimeout(t); var a=arguments, c=this; t=setTimeout(function(){ fn.apply(c,a); }, ms); }; }

  var BURRO_PAGE_CONFIG = window.BurroMtgSetPageConfig || {};
  var stateEl = qs('bs-state');
  var gridEl = qs('bs-cardsgrid');

  var setIconEl = qs('bs-set-icon');
  var setNameEl = qs('bs-set-name');
  var setStockBadgeEl = qs('bs-set-stock-badge');
  var setCodeEl = qs('bs-set-code');
  var setMetaEl = qs('bs-set-meta');

  var inSearchEl = qs('bs-card-search');
  var searchBtnEl = qs('bs-searchbtn');
  var colorEl = qs('bs-filter-color');
  var rarityEl = qs('bs-filter-rarity');
  var sortEl = qs('bs-sort');
  var onlyAvailEl = qs('bs-only-available');
  var clearEl = qs('bs-clear');
  var backEl = qs('bs-back');

  var loadMoreWrap = qs('bs-load-more-wrap');
  var loadMoreBtn = qs('bs-load-more');

  if (!gridEl || !stateEl) return;
  function setState(msg){ stateEl.textContent = msg; }

  function setStockBadge(kind, text){
    if (!setStockBadgeEl) return;
    setStockBadgeEl.classList.remove('checking','ok','no');
    setStockBadgeEl.classList.add(kind || 'checking');
    setStockBadgeEl.textContent = text || 'Verificando stock…';
  }

  function refreshSetStockBadge(){
    if (!setStockBadgeEl) return;

    var total = Array.isArray(allCards) ? allCards.length : 0;
    if (!total){
      setStockBadge('checking', 'Verificando stock…');
      return;
    }

    var known = 0;
    var available = 0;
    var seen = Object.create(null);

    allCards.forEach(function(c){
      var h = productHandleFor(SETCODE, cardCollector(c));
      if (!h || seen[h]) return;
      seen[h] = true;
      var info = productCache[h];
      if (!info) return;
      known++;
      if (info.exists && info.available) available++;
    });

    if (available > 0){
      setStockBadge('ok', stockFullScanDone ? (available + ' cartas disponibles') : 'Stock disponible');
      return;
    }

    if (stockFullScanDone){
      setStockBadge('no', 'Sin stock disponible');
      return;
    }

    if (known > 0){
      setStockBadge('checking', 'Revisando stock…');
      return;
    }

    setStockBadge('checking', 'Verificando stock…');
  }

  function kickLightSetStockCheck(){
    /*
      Revisión rápida en lotes:
      - Reutiliza la caché existente.
      - Consulta hasta 8 productos simultáneamente.
      - Se detiene apenas encuentra una carta disponible.
      - No bloquea el render ni consulta fuentes externas de cartas.
    */
    if (stockFullScanDone || stockLightScanPromise) return;

    stockLightScanPromise = (async function(){
      var handles = allCards.map(function(c){
        return productHandleFor(SETCODE, cardCollector(c));
      }).filter(Boolean);

      var seen = Object.create(null);
      handles = handles.filter(function(h){
        if (seen[h]) return false;
        seen[h] = true;
        return true;
      });

      refreshSetStockBadge();

      var batchSize = 8;
      for (var i=0; i<handles.length; i += batchSize){
        var batch = handles.slice(i, i + batchSize);
        var results = await Promise.all(batch.map(function(h){
          return productCache[h] ? Promise.resolve(productCache[h]) : fetchProductByHandle(h);
        }));

        refreshSetStockBadge();

        var found = results.some(function(info){
          return !!(info && info.exists && info.available);
        });

        if (found){
          stockLightScanPromise = null;
          return;
        }

        await sleep(45);
      }

      stockFullScanDone = true;
      stockLightScanPromise = null;
      refreshSetStockBadge();
    })();
  }

  function getParam(name){
    try{
      var u = new URL(window.location.href);
      return u.searchParams.get(name) || '';
    }catch(e){ return ''; }
  }

  var SETCODE = String(getParam('code') || '').trim().toLowerCase();
  if (!SETCODE){ setState('Falta el parámetro ?code=XXX'); return; }

  var SETS_RETURN_KEY = 'bs-mtg-sets-return-url';

  function isMtgSinglesUrl(rawUrl){
    try{
      var u = new URL(rawUrl, window.location.origin);
      return u.origin === window.location.origin &&
             u.pathname.replace(/\/$/, '') === '/pages/mtg-singles';
    }catch(e){
      return false;
    }
  }

  /*
    Guardamos la URL exacta desde la que se abrió la expansión.
    history.back() conserva además los filtros visuales gracias al historial
    del navegador; la URL guardada funciona como respaldo.
  */
  try{
    if (document.referrer && isMtgSinglesUrl(document.referrer)){
      sessionStorage.setItem(SETS_RETURN_KEY, document.referrer);
    }
    sessionStorage.setItem('bs-default-mode', 'set');
  }catch(e){}

  var CACHE_TTL_MS = 1000 * 60 * 20; // 20 minutos, compartido entre pestañas
  var CARDS_CACHE_KEY = 'bs_mtg_set_cards_engine_v1_' + SETCODE;
  var PRODUCT_CACHE_KEY = 'bs_mtg_set_products_' + SETCODE;

  function cacheRead(key){
    try{
      var raw = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.data) return null;
      if ((Date.now() - obj.t) > CACHE_TTL_MS){
        try{ localStorage.removeItem(key); }catch(_e){}
        try{ sessionStorage.removeItem(key); }catch(_e2){}
        return null;
      }
      return obj.data;
    }catch(e){
      return null;
    }
  }

  function cacheWrite(key, data){
    var payload = JSON.stringify({ t:Date.now(), data:data });
    try{ localStorage.setItem(key, payload); }
    catch(e){
      try{ sessionStorage.setItem(key, payload); }catch(_e){}
    }
  }

  var PAGE_SIZE = 60;
  var CONC_SHOPIFY = 8;
  var DELAY_SHOPIFY = 35;

  /* Escaneo completo al activar "En stock".
     Se usa por lotes grandes, sin espera artificial entre solicitudes. */
  var STOCK_SCAN_BATCH_SIZE = 24;
  var STOCK_SCAN_REQUEST_TIMEOUT_MS = 8000;
  var CONC_SCRYFALL_IMG = 3;
  var DELAY_SCRYFALL_IMG = 120;
  var DELAY_SCRYFALL = 140;
  var CONC_PACKS = 3;

  /* Burro Catalog SDK: único punto de acceso a Burro Engine. */
  if (!window.BurroCatalog){
    setState('No se cargó Burro Catalog SDK.');
    return;
  }
  window.BurroCatalog.configure({
    baseUrl:'https://burro-engine.pages.dev',
    cacheTtlMs:1000 * 60 * 20
  });

  /* Respaldos temporales mientras completamos la migración. */
  var ORACLE_ASSET_URL = BURRO_PAGE_CONFIG.oracleUrl || '/files/mtg-oracle-lite.json';
  var SETS_LOCAL_URL = BURRO_PAGE_CONFIG.setsUrl || '/files/burro-mtg-sets.json';
  var PACK_INDEX_URL = BURRO_PAGE_CONFIG.packIndexUrl || '/files/mtg-pack-index.json';
  var PACK_NEW_URL = BURRO_PAGE_CONFIG.packNewUrl || '/files/mtg-pack-new-001.json';
  var SCRY_SET_URL = 'https://api.scryfall.com/sets/' + encodeURIComponent(SETCODE);

  var PACK_ALL_FILES = [];
  for (var pn=1; pn<=23; pn++){
    PACK_ALL_FILES.push('mtg-pack-' + String(pn).padStart(3, '0') + '.json');
  }

  var TRANSPARENT_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

  function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms||0); }); }

  function withTimeout(promise, ms, label){
    return Promise.race([
      promise,
      new Promise(function(_resolve, reject){
        setTimeout(function(){
          reject(new Error((label || 'Operación') + ' excedió ' + ms + ' ms'));
        }, ms);
      })
    ]);
  }

  function formatMoneyCents(cents){
    var n = Number(cents || 0);
    if (!isFinite(n)) n = 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function'){
      try{ return window.Shopify.formatMoney(n, (window.Shopify.money_format || "${{amount}}")); }catch(e){}
    }
    return '$' + (n/100).toFixed(2);
  }

  function normalizeCollectorForHandle(collector){ return String(collector || '').trim().toLowerCase(); }
  function productHandleFor(setCodeLower, collector){
    var col = normalizeCollectorForHandle(collector);
    if (!setCodeLower || !col) return '';
    return setCodeLower + '-' + col;
  }

  function isDoubleFaced(c){ return !!(c && c.card_faces && c.card_faces.length >= 2); }
  function isMeld(c){ return String(c && c.layout || '').toLowerCase() === 'meld'; }
  function cardCollector(c){ return (c && c.collector_number) ? String(c.collector_number).trim() : ''; }
  function cardName(c){ return String(c && c.name || (c && c.card_faces && c.card_faces[0] && c.card_faces[0].name) || '').trim(); }
  function cardTypeLine(c){
    if (!c) return '';
    if (c.type_line) return c.type_line;
    if (c.card_faces && c.card_faces[0] && c.card_faces[0].type_line) return c.card_faces[0].type_line;
    return '';
  }

  function cardColorsGroup(c){
    var cols = [];
    if (Array.isArray(c.color_identity) && c.color_identity.length) cols = c.color_identity;
    else if (Array.isArray(c.colors) && c.colors.length) cols = c.colors;
    else if (c.card_faces && c.card_faces[0] && Array.isArray(c.card_faces[0].color_identity) && c.card_faces[0].color_identity.length) cols = c.card_faces[0].color_identity;
    else if (c.card_faces && c.card_faces[0] && Array.isArray(c.card_faces[0].colors) && c.card_faces[0].colors.length) cols = c.card_faces[0].colors;
    cols = cols.filter(Boolean);
    if (!cols.length) return 'C';
    if (cols.length >= 2) return 'M';
    return cols[0];
  }

  function cardImg(c, faceIndex, sizeKey){
    sizeKey = sizeKey || 'small';
    if (!c) return '';

    /* Formato Scryfall / legado. */
    if (c.image_uris && c.image_uris[sizeKey]) return c.image_uris[sizeKey];
    if (c.card_faces && c.card_faces[faceIndex] && c.card_faces[faceIndex].image_uris && c.card_faces[faceIndex].image_uris[sizeKey]){
      return c.card_faces[faceIndex].image_uris[sizeKey];
    }

    /* Formato Burro Engine. */
    if (typeof c.image === 'string' && c.image) return c.image;
    if (c.image && typeof c.image === 'object'){
      return c.image[sizeKey] || c.image.normal || c.image.large || c.image.small || '';
    }
    if (c.card_faces && c.card_faces[faceIndex]){
      var face = c.card_faces[faceIndex];
      if (typeof face.image === 'string' && face.image) return face.image;
      if (face.image && typeof face.image === 'object'){
        return face.image[sizeKey] || face.image.normal || face.image.large || face.image.small || '';
      }
      if (sizeKey === 'small' && face.image_small) return face.image_small;
      if (face.image_normal) return face.image_normal;
    }
    if (sizeKey === 'small' && c.image_small) return c.image_small;
    if (c.image_normal) return c.image_normal;

    return '';
  }

  function getLowestVariantPriceCents(product, onlyAvailable){
    var vars = (product && Array.isArray(product.variants)) ? product.variants : [];
    if (!vars.length) return null;
    var pick = vars;
    if (onlyAvailable){
      var avail = vars.filter(function(v){ return !!v.available; });
      if (avail.length) pick = avail;
    }
    var min = null;
    pick.forEach(function(v){
      var p = Number(v.price);
      if (!isFinite(p)) return;
      if (min === null || p < min) min = p;
    });
    return min;
  }
  function hasPrice(cents){ return !!(cents && cents > 0); }

  function variantOpt(v, n){
    return String((v && v['option' + n]) || '').trim();
  }


  function productOptionName(product, n){
    try{
      var opts = Array.isArray(product && product.options) ? product.options : [];
      var raw = opts[n-1];
      var name = (typeof raw === 'string') ? raw : (raw && raw.name);
      return String(name || (n === 1 ? 'Condición' : n === 2 ? 'Idioma' : 'Acabado')).trim();
    }catch(e){
      return n === 1 ? 'Condición' : n === 2 ? 'Idioma' : 'Acabado';
    }
  }

  function variantInventoryQty(v){
    if (!v) return null;

    var keys = [
      'inventory_quantity',
      'inventoryQuantity',
      'quantity',
      'qty',
      'available_quantity',
      'availableQuantity'
    ];

    for (var i=0;i<keys.length;i++){
      var val = v[keys[i]];
      if (val === undefined || val === null || val === '') continue;
      var n = Number(val);
      if (isFinite(n)) return Math.max(0, Math.floor(n));
    }

    return null;
  }

  function variantMaxQty(v){
    var q = variantInventoryQty(v);
    if (q !== null) return q;
    return (v && v.available) ? 1 : 0;
  }

  function normSkuPart(s){
    return String(s || '').trim().toUpperCase();
  }

  function normCollector(s){
    return String(s || '').trim().replace(/^0+/, '').toUpperCase();
  }

  function parseMtgSku(sku){
    var p = String(sku || '').trim().split('-').map(function(x){
      return String(x || '').trim();
    });

    return {
      raw: String(sku || '').trim(),
      set: normSkuPart(p[0]),
      collector: normCollector(p[1]),
      language: normSkuPart(p[2]),
      category: normSkuPart(p[3]),
      finish: normSkuPart(p[4]),
      condition: normSkuPart(p[5])
    };
  }

  function finishLabel(code){
    code = normSkuPart(code);
    if (code === 'R') return 'Regular';
    if (code === 'F') return 'Foil';
    if (code === 'E') return 'Etched';
    return code || '';
  }

  function variantSkuKey(v){
    return String(v && v.sku || '').trim().toUpperCase();
  }

  function skuMatchesCard(v, card){
    var sku = parseMtgSku(v && v.sku);
    if (!sku.set || !sku.collector) return true;
    return sku.set === normSkuPart(SETCODE) && sku.collector === normCollector(cardCollector(card));
  }

  function productTotalInventoryQty(product, card){
    var vars = Array.isArray(product && product.variants) ? product.variants : [];
    var total = 0;
    var hasExact = false;

    vars.forEach(function(v){
      if (!v || !v.available) return;
      if (card && !skuMatchesCard(v, card)) return;

      var q = variantInventoryQty(v);
      if (q !== null){
        hasExact = true;
        total += q;
      }
    });

    return hasExact ? total : null;
  }

  function productTotalInventoryBySku(product, sku){
    var vars = Array.isArray(product && product.variants) ? product.variants : [];
    var wanted = String(sku || '').trim().toUpperCase();
    if (!wanted) return null;

    var total = 0;
    var hasExact = false;

    vars.forEach(function(v){
      if (!v || !v.available) return;
      if (variantSkuKey(v) !== wanted) return;

      var q = variantInventoryQty(v);
      if (q !== null){
        hasExact = true;
        total += q;
      }
    });

    return hasExact ? total : null;
  }

  function variantDisplayStock(v, product, card){
    var q = variantInventoryQty(v);
    if (q !== null) return q;

    var bySku = productTotalInventoryBySku(product, v && v.sku);
    if (bySku !== null) return bySku;

    var total = productTotalInventoryQty(product, card);
    if (total !== null) return total;

    return null;
  }

  function variantLabel(v){
    var sku = parseMtgSku(v && v.sku);
    var bitsFromSku = [sku.language, finishLabel(sku.finish), sku.condition].filter(Boolean);
    if (bitsFromSku.length) return bitsFromSku.join(' / ');

    var bits = [variantOpt(v,1), variantOpt(v,2), variantOpt(v,3)].filter(Boolean);
    if (bits.length) return bits.join(' / ');
    return String(v && v.title || 'Variante').trim();
  }

  function uniq(arr){
    var seen = Object.create(null), out = [];
    (arr || []).forEach(function(x){
      x = String(x || '').trim();
      if (!x || seen[x]) return;
      seen[x] = true;
      out.push(x);
    });
    return out;
  }

  function findVariantByOptions(variants, selected){
    var available = (variants || []).filter(function(v){ return !!v.available; });
    var pool = available.length ? available : (variants || []);

    var exact = pool.find(function(v){
      return (!selected.o1 || variantOpt(v,1) === selected.o1) &&
             (!selected.o2 || variantOpt(v,2) === selected.o2) &&
             (!selected.o3 || variantOpt(v,3) === selected.o3);
    });
    return exact || pool[0] || null;
  }

  async function getCartVariantQty(variantId){
    try{
      var res = await fetch('/cart.js', { cache:'no-store', headers:{ 'Accept':'application/json' } });
      if (!res.ok) return 0;
      var cart = await res.json();
      var items = Array.isArray(cart && cart.items) ? cart.items : [];
      var found = items.filter(function(it){ return String(it.variant_id) === String(variantId); });
      return found.reduce(function(sum, it){ return sum + (Number(it.quantity) || 0); }, 0);
    }catch(e){
      return 0;
    }
  }

  async function addVariantToCart(variantId, qty){
    var res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body:JSON.stringify({ id:Number(variantId), quantity:Number(qty || 1) })
    });
    if (!res.ok){
      var txt = '';
      try{ txt = await res.text(); }catch(e){}
      throw new Error(txt || ('Error ' + res.status));
    }
    return await res.json();
  }

  function safeAvailableQtyForVariant(v, product, card){
    /*
      Si conocemos el stock real, devolvemos el máximo.
      Si NO lo conocemos, devolvemos null para NO limitar artificialmente a 1.
      En ese caso Shopify valida el inventario al agregar al carrito.
    */
    var exact = variantInventoryQty(v);
    if (exact !== null) return exact;

    var bySku = productTotalInventoryBySku(product, v && v.sku);
    if (bySku !== null) return bySku;

    var byCard = productTotalInventoryQty(product, card);
    if (byCard !== null) return byCard;

    return null;
  }

  async function refreshCartUI(){
    var cart = null;

    try{
      var res = await fetch('/cart.js', {
        cache:'no-store',
        headers:{ 'Accept':'application/json' }
      });
      if (res.ok) cart = await res.json();
    }catch(e){
      cart = null;
    }

    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;

    if (count !== null){
      [
        '[data-cart-count]',
        '.cart-count',
        '#CartCount',
        '[data-header-cart-count]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble span:not(.visually-hidden)'
      ].forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){
          el.textContent = String(count);
        });
      });

      document.querySelectorAll('.cart-count-bubble, [data-cart-count-bubble]').forEach(function(el){
        el.classList.remove('hidden');
        el.style.display = '';
      });
    }

    try{ document.dispatchEvent(new CustomEvent('cart:refresh', { detail:{ cart:cart } })); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart:cart } })); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart:change', { detail:{ cart:cart } })); }catch(e){}
    try{ window.dispatchEvent(new CustomEvent('cart:refresh', { detail:{ cart:cart } })); }catch(e){}

    return cart;
  }

  function renderVariantBuyBox(cardEl, pinfo){
    if (!cardEl || !cardEl.__bs) return;

    var buyBox = cardEl.querySelector('.bs-buybox');
    if (!buyBox) return;

    var product = pinfo && pinfo.product;
    var variants = (product && Array.isArray(product.variants)) ? product.variants.slice() : [];
    var card = cardEl.__bs && cardEl.__bs.card;
    var availableVariants = variants.filter(function(v){
      return !!v.available && skuMatchesCard(v, card);
    });

    if (!pinfo || !pinfo.exists || !availableVariants.length){
      buyBox.innerHTML = '';
      return;
    }

    buyBox.addEventListener('click', function(e){ e.stopPropagation(); });
    buyBox.addEventListener('change', function(e){ e.stopPropagation(); });

    buyBox.innerHTML =
      '<div class="bs-varrow">' +
        '<select class="bs-varselect bs-var-single" aria-label="Condición, idioma y acabado"></select>' +
      '</div>' +
      '' +
      '<div class="bs-qtyrow">' +
        '<button class="bs-qtybtn bs-minus" type="button" aria-label="Restar">−</button>' +
        '<input class="bs-qtyinput" type="number" min="1" value="1" inputmode="numeric">' +
        '<button class="bs-qtybtn bs-plus" type="button" aria-label="Sumar">+</button>' +
        '<button class="bs-addbtn" type="button">Agregar</button>' +
      '</div>' +
      '<div class="bs-addmsg"></div>';

    var selectEl = buyBox.querySelector('.bs-var-single');
    var priceEl = null;
    var stockEl = cardEl.querySelector('.bs-pill-stock');
    var qtyInput = buyBox.querySelector('.bs-qtyinput');
    var minusBtn = buyBox.querySelector('.bs-minus');
    var plusBtn = buyBox.querySelector('.bs-plus');
    var addBtn = buyBox.querySelector('.bs-addbtn');
    var msgEl = buyBox.querySelector('.bs-addmsg');

    availableVariants.forEach(function(v){
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = variantLabel(v);
      selectEl.appendChild(opt);
    });

    function selectedVariant(){
      return availableVariants.find(function(v){ return String(v.id) === String(selectEl.value); }) || availableVariants[0] || null;
    }

    function refresh(){
      var v = selectedVariant();
      var max = variantMaxQty(v);
      var current = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);

      /* Permitimos que el cliente escriba cualquier cantidad.
         Shopify valida el máximo real al agregar. */
      qtyInput.value = current;
      qtyInput.removeAttribute('max');

      if (stockEl){
        var inv = variantDisplayStock(v, product, card);
        stockEl.textContent = (inv !== null && inv > 0) ? ('Stock: ' + inv) : '';
      }

      var disabled = !v || !v.available || max <= 0;
      addBtn.disabled = disabled;
      if (minusBtn) minusBtn.disabled = disabled || current <= 1;
      if (plusBtn) plusBtn.disabled = disabled;
      qtyInput.disabled = disabled;
    }

    selectEl.addEventListener('change', function(){
      if (msgEl) msgEl.textContent = '';
      qtyInput.value = 1;
      refresh();
    });

    if (minusBtn){
      minusBtn.addEventListener('click', function(e){
        e.preventDefault();
        var n = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
        qtyInput.value = Math.max(1, n - 1);
        if (msgEl) msgEl.textContent = '';
        refresh();
      });
    }

    if (plusBtn){
      plusBtn.addEventListener('click', function(e){
        e.preventDefault();
        var v = selectedVariant();
        var max = variantMaxQty(v);
        var n = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
        qtyInput.value = n + 1;
        if (msgEl) msgEl.textContent = '';
        refresh();
      });
    }

    qtyInput.addEventListener('input', function(){
      var v = selectedVariant();
      var requested = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
      qtyInput.value = requested;
      if (msgEl) msgEl.textContent = '';
      refresh();
    });

    addBtn.addEventListener('click', async function(e){
      e.preventDefault();
      e.stopPropagation();
      var v = selectedVariant();
      if (!v || !v.id) return;

      var requested = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
      var alreadyInCart = await getCartVariantQty(v.id);
      var safeMax = safeAvailableQtyForVariant(v, product, card);
      var qty = requested;

      if (safeMax !== null){
        var remaining = Math.max(0, safeMax - alreadyInCart);
        qty = Math.min(requested, remaining);

        if (qty <= 0){
          if (msgEl) msgEl.textContent = 'Ya agregaste el máximo disponible para esta variante.';
          refresh();
          return;
        }
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Agregando…';
      if (msgEl) msgEl.textContent = '';

      try{
        await addVariantToCart(v.id, qty);
        await refreshCartUI();
        addBtn.textContent = 'Agregado ✓';

        if (msgEl){
          if (requested > qty){
            msgEl.textContent = 'Pediste ' + requested + ', pero solo agregamos ' + qty + ' disponible(s).';
          } else {
            msgEl.textContent = qty + ' agregado(s) al carrito.';
          }
        }

        refreshCartUI();
        setTimeout(function(){ addBtn.textContent = 'Agregar'; refresh(); }, 1400);
      }catch(err){
        addBtn.textContent = 'Agregar';
        if (msgEl) msgEl.textContent = 'No se pudo agregar.';
        refresh();
      }
    });

    refresh();
  }

  async function pooledMap(items, concurrency, delayMs, mapper){
    var i = 0;
    var out = new Array(items.length);
    var workers = new Array(Math.max(1, concurrency)).fill(0).map(async function(){
      while(true){
        var idx = i++;
        if (idx >= items.length) break;
        try{ out[idx] = await mapper(items[idx], idx); }
        catch(e){ out[idx] = null; }
        if (delayMs) await sleep(delayMs);
      }
    });
    await Promise.all(workers);
    return out;
  }

  async function tryFetchJson(url){
    try{
      if (!url || String(url).indexOf('{{') !== -1) return { ok:false, status:0, url:url, reason:'URL inválida' };
      var res = await fetch(url, { cache:'no-store' });
      if (!res.ok) return { ok:false, status:res.status, url:url, reason:'HTTP ' + res.status };
      var txt = await res.text();
      var head = (txt || '').trim().slice(0, 60).toLowerCase();
      if (head.startsWith('<!doctype') || head.startsWith('<html') || head.startsWith('<')){
        return { ok:false, status:res.status, url:url, reason:'No es JSON' };
      }
      var data = null;
      try{ data = JSON.parse(txt); }catch(e){ return { ok:false, status:res.status, url:url, reason:'JSON inválido' }; }
      return { ok:true, status:res.status, url:url, data:data };
    }catch(e){
      return { ok:false, status:0, url:url, reason:'Fetch error' };
    }
  }

  function stripQuery(u){ return String(u || '').split('?')[0]; }
  function baseDirFromUrl(u){
    try{
      var abs = new URL(u, window.location.origin).toString();
      abs = stripQuery(abs);
      return abs.substring(0, abs.lastIndexOf('/') + 1);
    }catch(e){
      u = stripQuery(u);
      return u.substring(0, u.lastIndexOf('/') + 1);
    }
  }

  function buildOracleCandidateUrls(){
    var urls = [];
    if (ORACLE_ASSET_URL && String(ORACLE_ASSET_URL).indexOf('{{') === -1) urls.push(String(ORACLE_ASSET_URL));
    urls.push('/files/mtg-oracle-lite.json');
    urls.push('/cdn/shop/files/mtg-oracle-lite.json');
    urls.push('/assets/mtg-oracle-lite.json');
    urls.push('/cdn/shop/assets/mtg-oracle-lite.json');
    var seen = {};
    return urls.filter(function(u){ u = String(u||'').trim(); if (!u || seen[u]) return false; seen[u] = true; return true; });
  }

  function buildPackCandidateUrls(filename){
    var out = [];
    var clean = String(filename || '').trim();
    if (!clean) return out;

    var dirIndex = baseDirFromUrl(PACK_INDEX_URL);
    if (dirIndex) out.push(dirIndex + clean);

    var dirNew = baseDirFromUrl(PACK_NEW_URL);
    if (dirNew) out.push(dirNew + clean);

    out.push('/files/' + clean);
    out.push('/cdn/shop/files/' + clean);
    out.push('/assets/' + clean);
    out.push('/cdn/shop/assets/' + clean);

    var seen = {};
    return out.filter(function(u){
      u = String(u || '').trim();
      if (!u || seen[u]) return false;
      seen[u] = true;
      return true;
    });
  }

  function coercePackCards(j){
    if (!j) return [];
    if (Array.isArray(j.cards)) return j.cards;
    if (Array.isArray(j.data)) return j.data;
    if (Array.isArray(j)) return j;
    return [];
  }

  function filterPaperEnSet(arr){
    return (arr || []).filter(function(c){
      if (!c) return false;
      if (String(c.set || '').toLowerCase() !== SETCODE) return false;
      var lang = String(c.lang || 'en').toLowerCase();
      if (lang && lang !== 'en') return false;
      if (Array.isArray(c.games) && c.games.length && c.games.indexOf('paper') === -1) return false;
      return true;
    });
  }

  function dedupeCards(cards){
    var seen = Object.create(null);
    var out = [];
    (cards || []).forEach(function(c){
      if (!c) return;
      var key = String(c.id || '').trim();
      if (!key){
        key = [
          String(c.set || '').toLowerCase(),
          String(c.collector_number || '').toLowerCase(),
          String(c.lang || 'en').toLowerCase(),
          String(c.name || '').toLowerCase()
        ].join('|');
      }
      if (seen[key]) return;
      seen[key] = true;
      out.push(c);
    });
    return out;
  }

  var allCards = [];
  var expectedSetCardCount = null;

  function sourceLooksComplete(cards){
    if (!Array.isArray(cards) || !cards.length) return false;
    if (expectedSetCardCount && expectedSetCardCount > 0){
      return cards.length >= Math.floor(expectedSetCardCount * 0.90);
    }
    return cards.length >= 120;
  }

  function isClearlyPartial(cards){
    if (!Array.isArray(cards) || !cards.length) return true;
    if (expectedSetCardCount && expectedSetCardCount > 0){
      return cards.length < Math.floor(expectedSetCardCount * 0.90);
    }
    return cards.length < 120;
  }

  var productCache = Object.assign(Object.create(null), cacheRead(PRODUCT_CACHE_KEY) || {});
  var stockFullScanDone = false;
  var stockFullScanPromise = null;
  var stockLightScanPromise = null;

  async function fetchInventoryByHandle(handle){
    try{
      var res = await fetch('/products/' + handle + '?view=inventory-json', {
        cache:'no-store',
        headers:{ 'Accept':'application/json' }
      });
      if (!res.ok) return null;
      var txt = await res.text();
      var clean = String(txt || '').trim();
      if (!clean || clean[0] !== '{') return null;
      return JSON.parse(clean);
    }catch(e){
      return null;
    }
  }

  function mergeInventoryIntoProduct(product, inv){
    if (!product || !inv || !Array.isArray(product.variants) || !Array.isArray(inv.variants)) return product;

    var byId = Object.create(null);
    var bySku = Object.create(null);

    inv.variants.forEach(function(v){
      if (!v) return;
      if (v.id !== undefined && v.id !== null) byId[String(v.id)] = v;
      if (v.sku) bySku[String(v.sku).trim().toUpperCase()] = v;
    });

    product.variants.forEach(function(v){
      if (!v) return;
      var match = byId[String(v.id)] || bySku[String(v.sku || '').trim().toUpperCase()];
      if (!match) return;

      if (match.inventory_quantity !== undefined && match.inventory_quantity !== null){
        v.inventory_quantity = Number(match.inventory_quantity);
      }
      if (match.available_quantity !== undefined && match.available_quantity !== null){
        v.available_quantity = Number(match.available_quantity);
      }
      if (match.inventory_management !== undefined){
        v.inventory_management = match.inventory_management;
      }
      if (match.inventory_policy !== undefined){
        v.inventory_policy = match.inventory_policy;
      }
    });

    return product;
  }

  async function fetchProductByHandleWithTimeout(handle){
    return withTimeout(
      fetchProductByHandle(handle),
      STOCK_SCAN_REQUEST_TIMEOUT_MS,
      'Inventario ' + handle
    ).catch(function(){
      return { exists:false, url:'/products/' + handle, available:false, product:null, _status:0, timeout:true };
    });
  }

  async function fetchProductByHandle(handle){
    if (!handle) return { exists:false, url:'', available:false, product:null, _status:0 };
    if (productCache[handle]) return productCache[handle];

    var out = { exists:false, url:'/products/' + handle, available:false, product:null, _status:0 };
    try{
      /*
        Una sola consulta por carta:
        /products/{handle}.js ya indica qué variantes están disponibles.
        El inventario numérico detallado se deja para la página del producto,
        evitando duplicar solicitudes durante la carga del set.
      */
      var res = await fetch('/products/' + handle + '.js', { cache:'force-cache' });
      out._status = res.status || 0;

      if (!res.ok){
        productCache[handle] = out;
        cacheWrite(PRODUCT_CACHE_KEY, productCache);
        return out;
      }

      var p = await res.json();
      out.exists = true;
      out.product = p;
      out.url = '/products/' + handle;

      var vars = Array.isArray(p.variants) ? p.variants : [];
      out.available = vars.some(function(v){ return !!v.available; });

      productCache[handle] = out;
      cacheWrite(PRODUCT_CACHE_KEY, productCache);
      return out;
    }catch(e){
      productCache[handle] = out;
      cacheWrite(PRODUCT_CACHE_KEY, productCache);
      return out;
    }
  }

  var scryExactCache = Object.create(null);
  async function fetchScryExactBySetCollector(setCodeLower, collector){
    try{
      var col = String(collector || '').trim();
      if (!setCodeLower || !col) return null;
      var key = setCodeLower + '|' + col;
      if (scryExactCache[key] !== undefined) return scryExactCache[key];
      var url = 'https://api.scryfall.com/cards/' + encodeURIComponent(setCodeLower) + '/' + encodeURIComponent(col);
      var r = await fetch(url, { cache:'no-store' });
      if (!r.ok){ scryExactCache[key] = null; return null; }
      var j = await r.json();
      scryExactCache[key] = j || null;
      return scryExactCache[key];
    }catch(e){ return null; }
  }

  function mergeImagesIntoCard(card, scry){
    if (!card || !scry) return card;
    if (!card.image_uris && scry.image_uris) card.image_uris = scry.image_uris;
    if (Array.isArray(card.card_faces) && Array.isArray(scry.card_faces)){
      for (var i=0;i<card.card_faces.length;i++){
        if (card.card_faces[i] && !card.card_faces[i].image_uris && scry.card_faces[i] && scry.card_faces[i].image_uris){
          card.card_faces[i].image_uris = scry.card_faces[i].image_uris;
        }
      }
    }
    if ((!card.all_parts || !card.all_parts.length) && scry.all_parts) card.all_parts = scry.all_parts;
    return card;
  }

  async function ensureCardHasImages(card){
    if (!card) return card;
    var hasAny =
      !!(card.image_uris && (card.image_uris.small || card.image_uris.normal || card.image_uris.large)) ||
      !!(card.card_faces && card.card_faces[0] && card.card_faces[0].image_uris && (card.card_faces[0].image_uris.small || card.card_faces[0].image_uris.normal || card.card_faces[0].image_uris.large));
    if (hasAny) return card;

    var scry = await fetchScryExactBySetCollector(SETCODE, cardCollector(card));
    if (scry) mergeImagesIntoCard(card, scry);
    await sleep(DELAY_SCRYFALL_IMG);
    return card;
  }

  var meldResultCache = Object.create(null);
  async function fetchMeldResultCard(card){
    try{
      if (!card || !isMeld(card)) return null;
      var key = (card.id ? ('id:' + card.id) : ('sc:' + SETCODE + ':' + cardCollector(card)));
      if (meldResultCache[key] !== undefined) return meldResultCache[key];

      var srcCard = card;
      if (!Array.isArray(srcCard.all_parts) || !srcCard.all_parts.length){
        var exact = await fetchScryExactBySetCollector(SETCODE, cardCollector(card));
        if (exact){ mergeImagesIntoCard(srcCard, exact); srcCard = exact; }
        await sleep(DELAY_SCRYFALL);
      }

      var parts = Array.isArray(srcCard.all_parts) ? srcCard.all_parts : [];
      var mr = parts.find(function(p){ return p && p.component === 'meld_result' && p.uri; });
      if (!mr || !mr.uri){ meldResultCache[key] = null; return null; }

      var r = await fetch(mr.uri, { cache:'no-store' });
      if (!r.ok){ meldResultCache[key] = null; return null; }
      var j = await r.json();
      meldResultCache[key] = j || null;
      return meldResultCache[key];
    }catch(e){ return null; }
  }

  async function loadSetMeta(){
    /* 1. Burro Engine: fuente principal. */
    try{
      var je = await window.BurroCatalog.getSets();
      {
        var ae = Array.isArray(je) ? je :
                 (Array.isArray(je.sets) ? je.sets :
                 (Array.isArray(je.data) ? je.data : []));
        var fe = ae.find(function(s){
          return String(s && s.code || '').toLowerCase() === SETCODE;
        });
        if (fe){
          applySetMetaFromSetObj(fe);
          return 'burro_engine';
        }
      }
    }catch(e){
      console.warn('[MTG SET] No se pudo cargar metadata desde Burro Engine', e);
    }

    /* 2. Shopify Files: respaldo temporal. */
    try{
      var r = await fetch(SETS_LOCAL_URL, { cache:'no-store' });
      if (r.ok){
        var j = await r.json();
        var arr = Array.isArray(j) ? j : (Array.isArray(j.data) ? j.data : []);
        var found = arr.find(function(s){ return String(s.code || '').toLowerCase() === SETCODE; });
        if (found){ applySetMetaFromSetObj(found); return 'shopify_files'; }
      }
    }catch(_e){}

    /* 3. Scryfall: respaldo final. */
    try{
      var r2 = await fetch(SCRY_SET_URL, { cache:'no-store' });
      if (r2.ok){
        var s2 = await r2.json();
        applySetMetaFromSetObj(s2);
        return 'scryfall';
      }
    }catch(_e2){}

    return 'unavailable';
  }

  function applySetMetaFromSetObj(s){
    try{
      var name = String(s.name || '').trim() || SETCODE.toUpperCase();
      var code = String(s.code || SETCODE).toUpperCase();
      var release = String(s.released_at || '').trim();
      var cards = (typeof s.count === 'number') ? s.count :
                  ((typeof s.card_count === 'number') ? s.card_count : null);
      expectedSetCardCount = cards;

      if (setNameEl) setNameEl.textContent = name;
      if (setCodeEl) setCodeEl.textContent = code;

      if (setIconEl){
        setIconEl.innerHTML = '';

        /*
          Burro Engine puede no incluir todavía el ícono del set.
          Usamos el SVG oficial por código como respaldo estable.
        */
        var codeLower = String(s.code || SETCODE || '').trim().toLowerCase();
        var primaryIcon = s.icon_svg_uri || s.icon_png_uri || '';
        var fallbackIcon = codeLower
          ? ('https://svgs.scryfall.io/sets/' + encodeURIComponent(codeLower) + '.svg')
          : '';

        if (primaryIcon || fallbackIcon){
          var img = document.createElement('img');
          img.src = primaryIcon || fallbackIcon;
          img.alt = name;
          img.loading = 'eager';
          img.decoding = 'async';

          img.addEventListener('error', function(){
            if (fallbackIcon && img.src !== fallbackIcon){
              img.src = fallbackIcon;
              return;
            }
            img.style.display = 'none';
          });

          setIconEl.appendChild(img);
        }
      }

      if (setMetaEl){
        var parts = [];
        if (release) parts.push('<span>Lanzamiento: ' + esc(release) + '</span>');
        if (cards !== null) parts.push('<span class="sep">·</span><span>' + esc(String(cards)) + ' cartas</span>');
        setMetaEl.innerHTML = parts.join('');
      }
    }catch(_e){}
  }

  async function loadOnePackByName(fname){
    var candidates = buildPackCandidateUrls(fname);
    for (var k=0;k<candidates.length;k++){
      var pr = await tryFetchJson(candidates[k]);
      if (pr.ok){
        return filterPaperEnSet(coercePackCards(pr.data));
      }
    }
    return [];
  }

  async function loadFromPacks(useAllPacks){
    var cards = [];
    var loadedNames = Object.create(null);

    try{
      var rNew = await tryFetchJson(PACK_NEW_URL);
      if (rNew.ok){
        cards = cards.concat(filterPaperEnSet(coercePackCards(rNew.data)));
      }
    }catch(_eNew){}

    try{
      var idxRes = await tryFetchJson(PACK_INDEX_URL);
      if (idxRes.ok){
        var idx = idxRes.data || {};
        var mapping = idx.set_to_packs || idx.setToPacks || idx.set_to_pack || idx.setToPack || null;
        var packList = mapping && mapping[SETCODE] ? mapping[SETCODE] : null;

        if (packList && packList.length){
          for (var i=0;i<packList.length;i++){
            var fname = String(packList[i] || '').trim();
            if (!fname) continue;
            loadedNames[fname] = true;
            cards = cards.concat(await loadOnePackByName(fname));
          }
        }
      }
    }catch(_eIdx){}

    cards = dedupeCards(cards);

    if (useAllPacks && isClearlyPartial(cards)){
      setState('Buscando en todos los archivos locales…');
      var missing = PACK_ALL_FILES.filter(function(fname){ return !loadedNames[fname]; });
      var results = await pooledMap(missing, CONC_PACKS, 0, async function(fname){
        return await loadOnePackByName(fname);
      });
      results.forEach(function(arr){ if (Array.isArray(arr) && arr.length) cards = cards.concat(arr); });
      cards = dedupeCards(cards);
    }

    allCards = cards;
    return !!allCards.length;
  }

  async function loadOracleOnly(){
    var urls = buildOracleCandidateUrls();
    for (var i=0;i<urls.length;i++){
      var r = await tryFetchJson(urls[i]);
      if (r.ok){
        var j = r.data;
        var arr = Array.isArray(j) ? j : (Array.isArray(j.data) ? j.data : []);
        allCards = dedupeCards(filterPaperEnSet(arr));
        if (allCards.length) return true;
      }
    }
    return false;
  }

  async function loadFromScryfallSet(){
    var url = 'https://api.scryfall.com/cards/search?order=set&q=' + encodeURIComponent('e:' + SETCODE + ' lang:en game:paper');
    var out = [];
    var safety = 0;

    while(url && safety < 60){
      safety++;
      var r = await fetch(url, { cache:'no-store' });
      if (!r.ok) break;
      var j = await r.json();
      if (Array.isArray(j.data)) out = out.concat(j.data);
      url = (j.has_more && j.next_page) ? j.next_page : null;
      if (url) await sleep(DELAY_SCRYFALL);
    }

    allCards = dedupeCards(out);
  }

  function normalizeEngineCard(record){
    if (!record) return null;

    var out = Object.assign({}, record);

    /* El código anterior espera nombres compatibles con Scryfall. */
    out.set = String(record.set || record.set_code || SETCODE).toLowerCase();
    out.set_name = record.set_name || record.expansion_name || '';
    out.collector_number = String(record.collector_number || record.number || '').trim();
    out.lang = String(record.lang || record.language || 'en').toLowerCase();
    out.games = Array.isArray(record.games) ? record.games : ['paper'];
    out.digital = !!record.digital;
    out.name = record.name || '';
    out.rarity = record.rarity || '';
    out.type_line = record.type_line || '';
    out.oracle_text = record.oracle_text || '';
    out.colors = Array.isArray(record.colors) ? record.colors : [];
    out.color_identity = Array.isArray(record.color_identity) ? record.color_identity : [];
    out.layout = record.layout || 'normal';

    if (!out.image_uris){
      var imageValue = record.image;
      if (typeof imageValue === 'string' && imageValue){
        out.image_uris = {
          small:imageValue,
          normal:imageValue,
          large:imageValue
        };
      } else if (imageValue && typeof imageValue === 'object'){
        out.image_uris = {
          small:imageValue.small || imageValue.normal || imageValue.large || '',
          normal:imageValue.normal || imageValue.large || imageValue.small || '',
          large:imageValue.large || imageValue.normal || imageValue.small || ''
        };
      }
    }

    if (Array.isArray(record.card_faces)){
      out.card_faces = record.card_faces.map(function(face){
        var f = Object.assign({}, face || {});
        if (!f.image_uris){
          var fi = f.image;
          if (typeof fi === 'string' && fi){
            f.image_uris = { small:fi, normal:fi, large:fi };
          } else if (fi && typeof fi === 'object'){
            f.image_uris = {
              small:fi.small || fi.normal || fi.large || '',
              normal:fi.normal || fi.large || fi.small || '',
              large:fi.large || fi.normal || fi.small || ''
            };
          } else if (f.image_small || f.image_normal){
            f.image_uris = {
              small:f.image_small || f.image_normal || '',
              normal:f.image_normal || f.image_small || '',
              large:f.image_normal || f.image_small || ''
            };
          }
        }
        return f;
      });
    }

    return out;
  }

  async function loadFromBurroEngine(){
    setState('Cargando expansión desde Burro Engine…');

    var payload = await window.BurroCatalog.getSet(SETCODE);
    var records = Array.isArray(payload) ? payload :
                  (Array.isArray(payload.records) ? payload.records :
                  (Array.isArray(payload.cards) ? payload.cards :
                  (Array.isArray(payload.data) ? payload.data : [])));

    if (!records.length){
      throw new Error('Burro Engine devolvió el set sin registros');
    }

    allCards = dedupeCards(records.map(normalizeEngineCard).filter(Boolean));

    if (!allCards.length){
      throw new Error('No fue posible normalizar los registros del set');
    }

    if (typeof payload.count === 'number'){
      expectedSetCardCount = payload.count;
    }

    return true;
  }

  async function loadCardsLocalFirst(){
    console.log('[MTG SET] Cargando set:', SETCODE, 'esperadas:', expectedSetCardCount);

    /*
      Fuente principal: Burro Engine.
      No recorremos packs antiguos ni Oracle porque podían dejar la página
      esperando durante mucho tiempo cuando un archivo faltaba o era parcial.
    */
    try{
      setState('Cargando cartas…');
      await withTimeout(loadFromBurroEngine(), 12000, 'Burro Engine');

      if (Array.isArray(allCards) && allCards.length){
        console.log('[MTG SET] Fuente final: burro_engine', allCards.length);
        return 'burro_engine';
      }

      throw new Error('Burro Engine no devolvió cartas');
    }catch(engineError){
      console.warn('[MTG SET] Burro Engine falló. Probando Scryfall.', engineError);
    }

    /*
      Respaldo único y explícito: Scryfall.
      También tiene tiempo máximo para que la interfaz nunca quede congelada.
    */
    try{
      setState('Usando respaldo externo…');
      await withTimeout(loadFromScryfallSet(), 25000, 'Scryfall');

      if (Array.isArray(allCards) && allCards.length){
        console.log('[MTG SET] Fuente final: scryfall', allCards.length);
        return 'scryfall';
      }
    }catch(scryError){
      console.error('[MTG SET] Scryfall también falló.', scryError);
    }

    allCards = [];
    return 'unavailable';
  }

  function buildCardElement(c){
    var name = cardName(c);
    var collector = cardCollector(c);
    var rarity = String(c.rarity || '').toLowerCase();
    var typeLine = cardTypeLine(c);
    var imgSmall = cardImg(c, 0, 'small');
    var imgLarge = cardImg(c, 0, 'normal');

    var cardEl = document.createElement('div');
    cardEl.className = 'bs-card';
    cardEl.dataset.collector = collector;
    cardEl.dataset.name = name.toLowerCase();
    cardEl.dataset.rarity = rarity;
    cardEl.dataset.colorgrp = cardColorsGroup(c);
    cardEl.dataset.layout = String(c.layout || '').toLowerCase();

    var imgWrap = document.createElement('div');
    imgWrap.className = 'bs-imgwrap';

    var img = document.createElement('img');
    img.className = 'bs-img';
    img.loading = 'lazy';
    img.alt = name;
    img.src = (imgSmall || imgLarge || TRANSPARENT_GIF);
    imgWrap.appendChild(img);

    var zoom = document.createElement('div');
    zoom.className = 'bs-zoom';

    var zoomBtn = document.createElement('button');
    zoomBtn.type = 'button';
    zoomBtn.className = 'bs-zoombtn';
    zoomBtn.textContent = '+';

    zoomBtn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();

      var getBack = async function(){
        var back = '';
        if (isDoubleFaced(c)){
          await ensureCardHasImages(c);
          back = cardImg(c, 1, 'normal') || cardImg(c, 1, 'large') || cardImg(c, 1, 'small') || '';
        }
        if (isMeld(c)){
          var mr = await fetchMeldResultCard(c);
          if (mr && mr.image_uris){
            back = mr.image_uris.normal || mr.image_uris.large || mr.image_uris.small || back;
          }
        }
        return back;
      };

      (async function(){
        await ensureCardHasImages(c);
        var front = cardImg(c, 0, 'normal') || cardImg(c, 0, 'large') || cardImg(c, 0, 'small') || '';
        window.openModal(front, getBack, name, c);

        var w = document.getElementById('bs-modalimgwrap');
        var im = document.getElementById('bs-modalimg');
        if (w && im){
          im.classList.remove('meld-top','meld-bottom');
          w.classList.remove('meld-back','meld-top-bg','meld-bottom-bg');
          w.style.removeProperty('--meld-bg');
        }
      })();
    });

    zoom.appendChild(zoomBtn);
    imgWrap.appendChild(zoom);
    cardEl.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'bs-cardbody';

    var info = document.createElement('div');
    info.className = 'bs-infoblock';
    info.innerHTML =
      '<p class="bs-name">' + esc(name) + '</p>' +
      '<div class="bs-sub">' +
        (collector ? '<span>#' + esc(collector) + '</span>' : '') +
        (rarity ? '<span class="dot">·</span><span>' + esc(rarity) + '</span>' : '') +
      '</div>' +
      '<p class="bs-price" style="display:none;"><span class="from">Desde:</span> <span class="value"></span></p>';
    body.appendChild(info);

    var availRow = document.createElement('div');
    availRow.className = 'bs-availability';

    var h = productHandleFor(SETCODE, collector);
    var cached = productCache[h];
    if (cached){
      if (cached.exists && cached.available){
        availRow.innerHTML = '<span class="bs-pill ok">Disponible · Ver más</span><span class="bs-pill-stock"></span>';
      } else {
        availRow.innerHTML = '<span class="bs-pill no">No disponible</span>';
      }
    } else {
      availRow.innerHTML = '<span class="bs-pill pending">Cargando…</span>';
    }
    body.appendChild(availRow);

    var buyBox = document.createElement('div');
    buyBox.className = 'bs-buybox';
    body.appendChild(buyBox);

    cardEl.appendChild(body);

    cardEl.__bs = {
      card:c,
      handle:h,
      pinfo:cached || null,
      cents:null,
      available:cached ? !!cached.available : false,
      imgEl:img
    };

    return cardEl;
  }

  function updateCardAvailability(cardEl, pinfo){
    if (!cardEl || !cardEl.__bs) return;
    var b = cardEl.__bs;
    b.pinfo = pinfo;
    b.available = !!(pinfo && pinfo.exists && pinfo.available);

    var priceP = cardEl.querySelector('.bs-price');
    var availWrap = cardEl.querySelector('.bs-availability');

    var cents = null;
    if (pinfo && pinfo.product) cents = getLowestVariantPriceCents(pinfo.product, true);
    b.cents = cents;

    if (priceP){
      if (hasPrice(cents)){
        var vars = (pinfo && pinfo.product && Array.isArray(pinfo.product.variants))
          ? pinfo.product.variants.filter(function(v){ return !!v.available; })
          : [];

        priceP.style.display = '';
        priceP.innerHTML =
          (vars.length > 1 ? '<span class="from">Desde</span>' : '') +
          esc(formatMoneyCents(cents));
      } else {
        priceP.style.display = 'none';
        priceP.textContent = '';
      }
    }

    if (availWrap){
      if (b.available){
        availWrap.innerHTML = '<span class="bs-pill ok">Disponible · Ver más</span><span class="bs-pill-stock"></span>';
        cardEl.style.cursor = 'default';
      } else {
        availWrap.innerHTML = '<span class="bs-pill no">No disponible</span>';
        cardEl.style.cursor = '';
      }
    }

    renderVariantBuyBox(cardEl, pinfo);
    refreshSetStockBadge();
  }

  function attachCardClick(cardEl){
    cardEl.addEventListener('click', function(e){
      var t = e.target;
      if (t && (t.classList.contains('bs-zoombtn') || (t.closest && (t.closest('.bs-zoom') || t.closest('.bs-buybox'))))) return;
      var b = cardEl.__bs;
      if (b && b.pinfo && b.pinfo.exists && b.pinfo.available){
        window.location.href = b.pinfo.url;
      }
    });
  }

  var viewCards = [];
  var renderedCount = 0;

  function applyFiltersAndSort(){
    var q = String(inSearchEl && inSearchEl.value || '').toLowerCase().trim();
    var col = String(colorEl && colorEl.value || '').trim();
    var rar = String(rarityEl && rarityEl.value || '').toLowerCase().trim();
    var onlyAvail = !!(onlyAvailEl && onlyAvailEl.checked);
    var sort = String(sortEl && sortEl.value || 'num');

    viewCards = allCards.filter(function(c){
      var name = cardName(c).toLowerCase();
      var type = cardTypeLine(c).toLowerCase();
      var collector = cardCollector(c);
      var rarity = String(c.rarity || '').toLowerCase();
      var cgrp = cardColorsGroup(c);

      if (q){
        var hay = (name + ' ' + type + ' ' + collector).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      if (col){
        if (col === 'M'){ if (cgrp !== 'M') return false; }
        else { if (cgrp !== col) return false; }
      }
      if (rar && rarity !== rar) return false;

      if (onlyAvail){
        var handle = productHandleFor(SETCODE, collector);
        var cached = productCache[handle];
        if (!(cached && cached.exists && cached.available)) return false;
      }
      return true;
    });

    if (sort === 'az' || sort === 'za'){
      viewCards.sort(function(a,b){
        var an = cardName(a).toLowerCase();
        var bn = cardName(b).toLowerCase();
        if (an === bn) return 0;
        return (sort === 'az') ? (an < bn ? -1 : 1) : (an < bn ? 1 : -1);
      });
    } else if (sort === 'price_asc' || sort === 'price_desc'){
      viewCards.sort(function(a,b){
        var ac = productCache[productHandleFor(SETCODE, cardCollector(a))];
        var bc = productCache[productHandleFor(SETCODE, cardCollector(b))];
        var ap = ac && ac.product ? getLowestVariantPriceCents(ac.product, true) : null;
        var bp = bc && bc.product ? getLowestVariantPriceCents(bc.product, true) : null;
        var aHas = hasPrice(ap);
        var bHas = hasPrice(bp);
        if (aHas !== bHas) return aHas ? -1 : 1;
        if (!aHas && !bHas) return 0;
        if (ap !== bp) return (sort === 'price_asc') ? (ap - bp) : (bp - ap);
        return 0;
      });
    } else {
      viewCards.sort(function(a,b){
        var an = String(cardCollector(a) || '');
        var bn = String(cardCollector(b) || '');
        var ai = parseInt(an, 10);
        var bi = parseInt(bn, 10);
        if (isFinite(ai) && isFinite(bi) && ai !== bi) return ai - bi;
        if (an !== bn) return an.localeCompare(bn, undefined, { numeric:true, sensitivity:'base' });
        return cardName(a).localeCompare(cardName(b));
      });
    }

    renderedCount = 0;
    gridEl.innerHTML = '';
    renderNextPage(true);
  }

  async function hydrateImagesForRendered(renderedEls){
    var need = renderedEls.filter(function(el){
      try{
        var c = el.__bs.card;
        var hasFront = !!(cardImg(c,0,'small') || cardImg(c,0,'normal') || cardImg(c,0,'large'));
        return !hasFront;
      }catch(e){ return false; }
    });
    if (!need.length) return;

    await pooledMap(need, CONC_SCRYFALL_IMG, DELAY_SCRYFALL_IMG, async function(el){
      var c = el.__bs.card;
      await ensureCardHasImages(c);
      var front = cardImg(c,0,'small') || cardImg(c,0,'normal') || cardImg(c,0,'large') || '';
      if (front && el.__bs && el.__bs.imgEl) el.__bs.imgEl.src = front;
      return true;
    });
  }

  var stockScanToken = 0;

  function setStockScanUiLocked(locked){
    var controls = [
      inSearchEl,
      searchBtnEl,
      colorEl,
      rarityEl,
      sortEl,
      onlyAvailEl,
      clearEl,
      backEl,
      loadMoreBtn
    ];

    controls.forEach(function(el){
      if (!el) return;
      el.disabled = !!locked;
      el.setAttribute('aria-busy', locked ? 'true' : 'false');
    });

    if (onlyAvailEl && onlyAvailEl.parentElement){
      onlyAvailEl.parentElement.style.opacity = locked ? '.62' : '';
      onlyAvailEl.parentElement.style.cursor = locked ? 'wait' : '';
    }

    if (gridEl){
      gridEl.style.pointerEvents = locked ? 'none' : '';
      gridEl.style.opacity = locked ? '.78' : '';
    }
  }

  async function scanAllStockThrottled(){
    if (stockFullScanDone) return;
    if (stockFullScanPromise) return stockFullScanPromise;

    stockFullScanPromise = (async function(){
      var handles = allCards.map(function(c){
        return productHandleFor(SETCODE, cardCollector(c));
      }).filter(Boolean);

      var seen = Object.create(null);
      handles = handles.filter(function(h){
        if (seen[h]) return false;
        seen[h] = true;
        return true;
      });

      /*
        El total corresponde a todas las cartas únicas del set.
        Las que ya están en caché cuentan como verificadas desde el inicio.
      */
      var totalHandles = handles.length;
      var pendingHandles = handles.filter(function(h){ return !productCache[h]; });
      var done = totalHandles - pendingHandles.length;

      setStockScanUiLocked(true);
      setState('Verificando stock... ' + done + ' de ' + totalHandles);

      try{
        if (!pendingHandles.length){
          stockFullScanDone = true;
          refreshSetStockBadge();
          return;
        }

        for (var i=0; i<pendingHandles.length; i += STOCK_SCAN_BATCH_SIZE){
          var batch = pendingHandles.slice(i, i + STOCK_SCAN_BATCH_SIZE);

          await Promise.allSettled(batch.map(function(handle){
            return fetchProductByHandleWithTimeout(handle);
          }));

          done += batch.length;
          refreshSetStockBadge();
          setState(
            'Verificando stock... ' +
            Math.min(done, totalHandles) +
            ' de ' +
            totalHandles
          );

          await sleep(0);
        }

        stockFullScanDone = true;
        refreshSetStockBadge();

        var availableCount = 0;
        handles.forEach(function(handle){
          var info = productCache[handle];
          if (info && info.exists && info.available) availableCount++;
        });

        setState(
          totalHandles +
          ' cartas verificadas · ' +
          availableCount +
          ' disponibles'
        );
      } finally {
        stockFullScanPromise = null;
        setStockScanUiLocked(false);
      }
    })();

    return stockFullScanPromise;
  }

  function renderNextPage(isFresh){
    var total = viewCards.length;
    if (!total){
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
      setState('Sin resultados con esos filtros.');
      return;
    }

    var next = viewCards.slice(renderedCount, renderedCount + PAGE_SIZE);
    if (!next.length){
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
      setState(total + ' cartas');
      return;
    }

    var frag = document.createDocumentFragment();
    var renderedEls = [];

    next.forEach(function(c){
      var el = buildCardElement(c);
      attachCardClick(el);
      frag.appendChild(el);
      renderedEls.push(el);
    });
    gridEl.appendChild(frag);

    hydrateImagesForRendered(renderedEls);

    pooledMap(renderedEls, CONC_SHOPIFY, DELAY_SHOPIFY, async function(el){
      if (!el || !el.__bs || !el.__bs.handle) return null;

      var handle = el.__bs.handle;
      var pinfo = productCache[handle] || await fetchProductByHandle(handle);

      /* Siempre actualizar la tarjeta, incluso si no existe o no está disponible. */
      updateCardAvailability(el, pinfo);

      return true;
    }).then(function(){
      setState(Math.min(renderedCount, total) + ' de ' + total + ' cartas');
    }).catch(function(){
      renderedEls.forEach(function(el){
        if (!el || !el.__bs) return;
        var pinfo = productCache[el.__bs.handle] || { exists:false, available:false, product:null };
        updateCardAvailability(el, pinfo);
      });
      setState(Math.min(renderedCount, total) + ' de ' + total + ' cartas');
    });

    renderedCount += next.length;

    if (loadMoreWrap){
      loadMoreWrap.style.display = (renderedCount < total) ? 'block' : 'none';
    }
    if (!isFresh) setState(renderedCount + ' de ' + total + ' cartas');
  }

  var debApply = debounce(applyFiltersAndSort, 160);
  if (inSearchEl) inSearchEl.addEventListener('input', debApply);
  if (searchBtnEl) searchBtnEl.addEventListener('click', applyFiltersAndSort);
  if (inSearchEl) inSearchEl.addEventListener('keydown', function(e){ if (e.key === 'Enter') applyFiltersAndSort(); });
  if (colorEl) colorEl.addEventListener('change', debApply);
  if (rarityEl) rarityEl.addEventListener('change', debApply);
  if (sortEl) sortEl.addEventListener('change', debApply);

  async function handleStockFilterChange(){
    if (!onlyAvailEl) return;

    if (onlyAvailEl.checked){
      /*
        Conservamos la cuadrícula visible y bloqueamos interacciones
        únicamente durante la verificación completa.
      */
      await scanAllStockThrottled();
      applyFiltersAndSort();
    } else {
      applyFiltersAndSort();
    }
  }

  if (onlyAvailEl){
    onlyAvailEl.addEventListener('change', handleStockFilterChange);
  }

  if (clearEl) clearEl.addEventListener('click', function(){
    if (inSearchEl) inSearchEl.value = '';
    if (colorEl) colorEl.value = '';
    if (rarityEl) rarityEl.value = '';
    if (sortEl) sortEl.value = 'num';
    if (onlyAvailEl){ onlyAvailEl.checked = false; }
    applyFiltersAndSort();
  });

if (backEl){
  backEl.addEventListener('click', function(){
    /*
      No usamos history.back():
      el navegador puede restaurar el modo Buscar por carta y la posición
      anterior al final de la página mediante su caché de navegación.

      Abrimos una URL nueva y explícita:
      - view=sets obliga el modo Buscar por set.
      - #bs-sets-page lleva al inicio del módulo.
    */
    try{
      sessionStorage.setItem('bs-default-mode', 'set');
      sessionStorage.setItem('bs-force-sets-top', '1');
    }catch(e){}

    window.location.assign('/pages/mtg-singles?view=sets');
  });
}

  if (loadMoreBtn) loadMoreBtn.addEventListener('click', function(){
    renderNextPage(false);
  });

  async function boot(){
    try{
      setState('Cargando set…');

      /*
        La metadata no debe bloquear las cartas. Si falla, usamos el código
        como título temporal y continuamos.
      */
      try{
        await withTimeout(loadSetMeta(), 8000, 'Metadata del set');
      }catch(metaError){
        console.warn('[MTG SET] Metadata no disponible', metaError);
        if (setNameEl) setNameEl.textContent = SETCODE.toUpperCase();
        if (setCodeEl) setCodeEl.textContent = SETCODE.toUpperCase();
      }

      var cachedCards = cacheRead(CARDS_CACHE_KEY);
      var source = 'cache';

      if (Array.isArray(cachedCards) && cachedCards.length){
        allCards = cachedCards;
      } else {
        source = await loadCardsLocalFirst();

        if (Array.isArray(allCards) && allCards.length){
          cacheWrite(CARDS_CACHE_KEY, allCards);
        }
      }

      if (!Array.isArray(allCards) || !allCards.length){
        gridEl.innerHTML = '';
        setStockBadge('no', 'Sin datos disponibles');
        setState('No fue posible cargar esta expansión. Recarga la página o prueba nuevamente.');
        return;
      }

      /*
        Pintamos primero. La consulta de Shopify ocurre después, únicamente
        para las tarjetas visibles, sin bloquear el catálogo.
      */
      setStockBadge('checking', 'Stock por carta');
      applyFiltersAndSort();

      console.log('[MTG SET] Listo:', source, allCards.length, 'cartas');
    }catch(error){
      console.error('[MTG SET] Error de inicio', error);
      gridEl.innerHTML = '';
      setStockBadge('no', 'Error de carga');
      setState('Ocurrió un error al cargar la expansión. Revisa la consola o intenta nuevamente.');
    }
  }

  boot();
})();
